import Marrakesh1 from "./marrakesh (1).webp";
import Marrakesh2 from "./marrakesh (2).webp";
import Marrakesh3 from "./marrakesh (3).webp";
import Marrakesh4 from "./marrakesh (4).webp";
import Marrakesh5 from "./marrakesh (5).webp";
import Marrakesh6 from "./marrakesh (6).webp";

const marrakesh = [
  Marrakesh1,
  Marrakesh2,
  Marrakesh3,
  Marrakesh4,
  Marrakesh5,
  Marrakesh6,
];

export default marrakesh;
